"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var hooks_1 = require("preact/hooks");
var api_1 = require("../api");
var SelectField_1 = require("./SelectField");
var ProjectExperience_1 = require("./ProjectExperience");
var ProjectSubmit_1 = require("./ProjectSubmit");
var ProjectDates_1 = require("./ProjectDates");
var i18n_1 = require("@wordpress/i18n");
var lib_1 = require("../lib");
var SubmitButton_1 = require("./SubmitButton");
function TripDetails(_a) {
    var _this = this;
    var productLineId = _a.productLineId, defaults = _a.defaults, studyAbroadTripTypeId = _a.studyAbroadTripTypeId;
    var _b = (0, hooks_1.useState)([]), destinations = _b[0], setDestinations = _b[1];
    var _c = (0, hooks_1.useState)([]), projects = _c[0], setProjects = _c[1];
    var _d = (0, hooks_1.useState)(""), selectedDestinationId = _d[0], setSelectedDestinationId = _d[1];
    var _e = (0, hooks_1.useState)(""), selectedProjectId = _e[0], setSelectedProjectId = _e[1];
    var _f = (0, hooks_1.useState)(null), project = _f[0], setProject = _f[1];
    var _g = (0, hooks_1.useState)(false), isValid = _g[0], setIsValid = _g[1];
    var _h = (0, hooks_1.useState)(false), queryStringApplied = _h[0], setQueryStringApplied = _h[1];
    var destinationsFieldRef = (0, hooks_1.useRef)(null);
    var projectsFieldRef = (0, hooks_1.useRef)(null);
    var datesFieldRef = (0, hooks_1.useRef)(null);
    var projectExperienceRef = (0, hooks_1.useRef)(null);
    var updateDestinations = function () { return __awaiter(_this, void 0, void 0, function () {
        var results;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, api_1.getDestinations)(productLineId)];
                case 1:
                    results = _a.sent();
                    setDestinations(results);
                    return [2 /*return*/];
            }
        });
    }); };
    var updateProjects = function () { return __awaiter(_this, void 0, void 0, function () {
        var results;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, api_1.getProjects)(productLineId, selectedDestinationId)];
                case 1:
                    results = _a.sent();
                    setProjects(results);
                    return [2 /*return*/];
            }
        });
    }); };
    var updateProject = function () { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, api_1.getProject)(selectedDestinationId, selectedProjectId)];
                case 1:
                    result = _a.sent();
                    setProject(result);
                    return [2 /*return*/];
            }
        });
    }); };
    (0, hooks_1.useEffect)(function () {
        if (productLineId !== "") {
            updateDestinations();
        }
    }, []);
    (0, hooks_1.useEffect)(function () {
        if (!queryStringApplied) {
            if (destinations.length !== 0 && 'destinationId' in defaults) {
                setSelectedDestinationId(defaults.destinationId);
            }
            if (projects.length !== 0 && 'projectId' in defaults) {
                setSelectedProjectId(defaults.projectId);
                setQueryStringApplied(true);
            }
        }
    }, [destinations, projects, project]);
    // When the destination is changed, reset the projects
    (0, hooks_1.useEffect)(function () {
        setSelectedProjectId("");
        setProjects([]);
        if (selectedDestinationId !== "") {
            updateProjects();
        }
    }, [selectedDestinationId]);
    // When the project is changed, update the project details
    (0, hooks_1.useEffect)(function () {
        setProject(null);
        if (selectedProjectId !== "") {
            updateProject();
        }
    }, [selectedProjectId]);
    if (destinations.length === 0) {
        return null;
    }
    var hasProjects = projects.length > 0;
    var projectsFieldOnMount = function (element) {
        if (hasProjects && destinationsFieldRef.current && element.current) {
            window.requestAnimationFrame(function () {
                if (!(0, lib_1.isVisibleInViewport)(this)) {
                    (0, lib_1.scrollToElement)(destinationsFieldRef.current);
                }
            }.bind(element.current));
        }
    };
    var datesFieldOnMount = function (element) {
        if (hasProjects && selectedProjectId && projectsFieldRef.current && element.current) {
            window.requestAnimationFrame(function () {
                if (!(0, lib_1.isVisibleInViewport)(this)) {
                    (0, lib_1.scrollToElement)(projectsFieldRef.current);
                }
            }.bind(element.current));
        }
    };
    var projectExperienceOnMount = function (element) {
        if (isValid && datesFieldRef.current && element.current) {
            window.requestAnimationFrame(function () {
                if (!(0, lib_1.isVisibleInViewport)(this)) {
                    (0, lib_1.scrollToElement)(element.current);
                }
            }.bind(element.current));
        }
    };
    var isStudyAbroad = (project === null || project === void 0 ? void 0 : project.tripTypeId) === studyAbroadTripTypeId;
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "appform-destination-details" }, { children: [(0, jsx_runtime_1.jsx)(SelectField_1.default, { ref: destinationsFieldRef, name: "destination_id", label: (0, i18n_1.__)("Choose your destination", "projects-abroad"), options: destinations, defaultOptionLabel: (0, i18n_1.__)("Select a destination", "projects-abroad"), value: selectedDestinationId, required: true, onChange: function (e) { return setSelectedDestinationId(e.target.value); } }), hasProjects && ((0, jsx_runtime_1.jsx)(SelectField_1.default, { ref: projectsFieldRef, onMount: projectsFieldOnMount, name: "project_id", label: (0, i18n_1.__)("Select your project", "projects-abroad"), sublabel: (0, i18n_1.__)(" – can't find the project you're looking for?", "projects-abroad"), sublabelExtraLine: (0, i18n_1.__)("Get in touch + 44 (0)1273 007 230", "projects-abroad"), options: projects, defaultOptionLabel: (0, i18n_1.__)("Select a project", "projects-abroad"), value: selectedProjectId, required: true, onChange: function (e) { return setSelectedProjectId(e.target.value); } })), hasProjects && selectedProjectId && !isStudyAbroad && ((0, jsx_runtime_1.jsx)(ProjectDates_1.default, { ref: datesFieldRef, onMount: datesFieldOnMount, project: project, setIsValid: setIsValid, isValid: isValid, defaultStartDate: 'startDate' in defaults ? defaults.startDate : '', defaultDurationDays: 'durationDays' in defaults ? defaults.durationDays : '' })), hasProjects && project && selectedProjectId && ((0, jsx_runtime_1.jsx)("input", { type: "hidden", name: "trip_type_id", value: project.tripTypeId || '' })), isStudyAbroad && ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: { __html: window.appformStudyAbroadDescription || '' } }), (0, jsx_runtime_1.jsx)("div", __assign({ class: "appform-buttons-group" }, { children: (0, jsx_runtime_1.jsx)(SubmitButton_1.default, { label: (0, i18n_1.__)("Continue", "projects-abroad"), value: "continue" }) }))] }))] })), isValid && !isStudyAbroad && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ProjectExperience_1.default, { ref: projectExperienceRef, onMount: projectExperienceOnMount, project: project }), (0, jsx_runtime_1.jsx)(ProjectSubmit_1.default, {})] }))] }));
}
exports.default = TripDetails;
